module.exports = __webpack_public_path__ + "static/media/spending_infographic.b4a98fcb.svg";